/* ============================================================
   Collection Pagination — JS-driven client-side pagination
   Used by: sections/main-collection-custom.liquid
   PER_PAGE is read from data-per-page on #product-grid
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const PER_PAGE = parseInt(grid.getAttribute('data-per-page') || '16', 10);
  const cards = [...grid.querySelectorAll('.product-card')];
  if (cards.length === 0) return;

  const totalPages = Math.ceil(cards.length / PER_PAGE);
  let currentPage = 1;

  const scrollToGrid = () => {
    window.scrollTo({ top: grid.offsetTop - 100, behavior: 'smooth' });
  };

  const showPage = (page) => {
    currentPage = page;
    const start = (page - 1) * PER_PAGE;
    const end = page * PER_PAGE;
    cards.forEach((card, i) => {
      card.style.display = (i >= start && i < end) ? '' : 'none';
    });
    renderNav();
  };

  const buildNav = () => {
    if (totalPages <= 1) return null;

    const nav = document.createElement('nav');
    nav.className = 'custom-pagination js-pagination-nav';
    nav.setAttribute('role', 'navigation');

    if (currentPage > 1) {
      const prev = document.createElement('span');
      prev.className = 'pagination__item';
      prev.innerHTML = '&laquo;';
      prev.addEventListener('click', () => { showPage(currentPage - 1); scrollToGrid(); });
      nav.appendChild(prev);
    }

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement('span');
      btn.className = 'pagination__item' + (i === currentPage ? ' active' : '');
      btn.textContent = i;
      btn.addEventListener('click', () => { showPage(i); scrollToGrid(); });
      nav.appendChild(btn);
    }

    if (currentPage < totalPages) {
      const next = document.createElement('span');
      next.className = 'pagination__item';
      next.innerHTML = '&raquo;';
      next.addEventListener('click', () => { showPage(currentPage + 1); scrollToGrid(); });
      nav.appendChild(next);
    }

    return nav;
  };

  const renderNav = () => {
    const top = document.getElementById('js-pagination-top');
    const bottom = document.getElementById('js-pagination-bottom');
    if (top) { top.innerHTML = ''; const n = buildNav(); if (n) top.appendChild(n); }
    if (bottom) { bottom.innerHTML = ''; const n2 = buildNav(); if (n2) bottom.appendChild(n2); }
  };

  showPage(1);
});
